import React from 'react';
import Navbar from '../../components/Navbar/Navbar';
import Footer from '../../sections/Footer/Footer';
import SEO from '../../components/SEO/SEO';
import './Datenschutz.scss';

const Datenschutz = () => {
    return (
        <>
            <SEO
                title="Datenschutzerklärung | Zahnarztpraxis Roman Boretskyi"
                description="Informationen zum Datenschutz der Zahnarztpraxis Roman Boretskyi in Tönisvorst."
                path="/datenschutz"
                noindex
            />
            <Navbar />
            <section className='section-bg section-common datenschutz-section pt-100 pb-70'>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-10 mx-auto">
                            <h1>Datenschutzerklärung</h1>
                            
                            <h2>1. Datenschutz auf einen Blick</h2>
                            
                            <h3>Allgemeine Hinweise</h3>
                            <p>
                                Die folgenden Hinweise geben einen einfachen Überblick darüber, 
                                was mit Ihren personenbezogenen Daten passiert, wenn Sie diese 
                                Website besuchen. Personenbezogene Daten sind alle Daten, mit 
                                denen Sie persönlich identifiziert werden können.
                            </p>

                            <h3>Datenerfassung auf dieser Website</h3>
                            <p>
                                <strong>Wer ist verantwortlich für die Datenerfassung auf dieser Website?</strong><br />
                                Die Datenverarbeitung auf dieser Website erfolgt durch den 
                                Websitebetreiber. Dessen Kontaktdaten können Sie dem Abschnitt 
                                „Hinweis zur Verantwortlichen Stelle" in dieser Datenschutzerklärung entnehmen.
                            </p>

                            <p>
                                <strong>Wie erfassen wir Ihre Daten?</strong><br />
                                Ihre Daten werden zum einen dadurch erhoben, dass Sie uns diese 
                                mitteilen. Hierbei kann es sich z. B. um Daten handeln, die Sie 
                                in ein Kontaktformular eingeben.
                            </p>

                            <p>
                                <strong>Wofür nutzen wir Ihre Daten?</strong><br />
                                Ein Teil der Daten wird erhoben, um eine fehlerfreie Bereitstellung 
                                der Website zu gewährleisten. Wir verwenden auf dieser Website keine 
                                Tools zur Analyse Ihres Nutzungsverhaltens.
                            </p>

                            <h2>2. Verantwortliche Stelle</h2>
                            <p>
                                Die verantwortliche Stelle für die Datenverarbeitung auf dieser 
                                Website ist:
                            </p>
                            <p>
                                Zahnarztpraxis Roman Boretskyi<br />
                                Roman Boretskyi<br />
                                Kornstraße 53a<br />
                                47918 Tönisvorst<br />
                                Deutschland
                            </p>
                            <p>
                                Telefon: 02151803208<br />
                                E-Mail: anmeldung@zahnarzt-st-toenis.de
                            </p>

                            <h2>3. Allgemeine Hinweise und Pflichtinformationen</h2>
                            
                            <h3>Datenschutz</h3>
                            <p>
                                Die Betreiber dieser Seiten nehmen den Schutz Ihrer persönlichen 
                                Daten sehr ernst. Wir behandeln Ihre personenbezogenen Daten 
                                vertraulich und entsprechend den gesetzlichen Datenschutzbestimmungen 
                                sowie dieser Datenschutzerklärung.
                            </p>

                            <h3>Hinweis zur verantwortlichen Stelle</h3>
                            <p>
                                Die verantwortliche Stelle für die Datenverarbeitung auf dieser 
                                Website ist in der Rubrik "Verantwortliche Stelle" dieser 
                                Datenschutzerklärung aufgeführt.
                            </p>

                            <h3>Speicherdauer</h3>
                            <p>
                                Soweit innerhalb dieser Datenschutzerklärung keine speziellere 
                                Speicherdauer genannt wurde, verbleiben Ihre personenbezogenen 
                                Daten bei uns, bis der Zweck für die Datenverarbeitung entfällt. 
                                Wenn Sie ein berechtigtes Löschersuchen geltend machen oder eine 
                                Einwilligung zur Datenverarbeitung widerrufen, werden Ihre Daten 
                                gelöscht, sofern wir keine anderen rechtlich zulässigen Gründe 
                                für die Speicherung Ihrer personenbezogenen Daten haben.
                            </p>

                            <h2>4. Hosting</h2>
                            <p>
                                Diese Website wird gehostet bei:
                            </p>
                            <p>
                                <strong>Strato AG</strong><br />
                                Pascalstraße 10<br />
                                10587 Berlin<br />
                                Deutschland
                            </p>
                            <p>
                                Der Hoster erhebt in sog. Logfiles folgende Daten, die Ihr Browser 
                                übermittelt:
                            </p>
                            <ul>
                                <li>IP-Adresse</li>
                                <li>Zeitpunkt des Zugriffs (Timestamp)</li>
                                <li>Aufgerufene Seite/URL</li>
                                <li>Browser-Typ und -Version</li>
                                <li>Referrer-URL (die zuvor besuchte Seite)</li>
                            </ul>
                            <p>
                                Die Server-Logfiles werden für Zwecke der technischen Bereitstellung, 
                                IT-Sicherheit und Fehleranalyse verarbeitet und werden gelöscht, sobald 
                                sie für die genannten Zwecke nicht mehr erforderlich sind, sofern keine 
                                weitere Aufbewahrung zu Beweiszwecken erforderlich ist.
                            </p>
                            <p>
                                <strong>Rechtsgrundlage:</strong> Die Verarbeitung erfolgt auf 
                                Grundlage von Art. 6 Abs. 1 lit. f DSGVO zur Wahrung unserer 
                                berechtigten Interessen an einer sicheren und stabilen Bereitstellung 
                                der Website.
                            </p>
                            <p>
                                <strong>Auftragsverarbeitung:</strong> Strato AG ist unser 
                                Auftragsverarbeiter gemäß Art. 28 DSGVO. Es besteht ein 
                                Auftragsverarbeitungsvertrag (AV-Vertrag) zwischen uns und 
                                der Strato AG.
                            </p>

                            <h2>5. Datenerfassung auf dieser Website</h2>
                            
                            <h3>Kontaktformular</h3>
                            <p>
                                Wenn Sie uns per Kontaktformular Anfragen zukommen lassen, werden 
                                Ihre Angaben aus dem Anfrageformular inklusive der von Ihnen dort 
                                angegebenen Kontaktdaten zwecks Bearbeitung der Anfrage und für 
                                den Fall von Anschlussfragen bei uns gespeichert.
                            </p>
                            <p>
                                <strong>Rechtsgrundlage:</strong> Die Verarbeitung Ihrer Angaben aus 
                                dem Kontaktformular erfolgt zur Bearbeitung Ihrer Anfrage. Soweit Ihre 
                                Anfrage auf den Abschluss bzw. die Durchführung eines Behandlungsvertrags 
                                gerichtet ist (z. B. Terminwünsche), ist Rechtsgrundlage Art. 6 Abs. 1 
                                lit. b DSGVO (Vertrag bzw. vorvertragliche Maßnahmen). In allen anderen 
                                Fällen erfolgt die Verarbeitung auf Grundlage von Art. 6 Abs. 1 lit. f 
                                DSGVO (berechtigtes Interesse an der Bearbeitung von Anfragen).
                            </p>
                            <p>
                                <strong>Speicherdauer:</strong> Die Daten werden gelöscht, sobald 
                                sie für die Bearbeitung Ihrer Anfrage nicht mehr erforderlich sind 
                                und keine gesetzlichen Aufbewahrungspflichten entgegenstehen.
                            </p>

                            <h3>SSL- bzw. TLS-Verschlüsselung</h3>
                            <p>
                                Diese Seite nutzt aus Sicherheitsgründen und zum Schutz der 
                                Übertragung vertraulicher Inhalte, wie zum Beispiel Bestellungen 
                                oder Anfragen, die Sie an uns als Seitenbetreiber senden, eine 
                                SSL- bzw. TLS-Verschlüsselung. Eine verschlüsselte Verbindung 
                                erkennen Sie daran, dass die Adresszeile des Browsers von "http://" 
                                auf "https://" wechselt und an dem Schloss-Symbol in Ihrer Browserzeile.
                            </p>

                            <h3>Cookies und Tracking</h3>
                            <p>
                                Wir verwenden auf dieser Website keine Analyse-Tools, keine Tracking-Cookies 
                                und keine anderen Technologien zur Analyse Ihres Nutzungsverhaltens.
                            </p>

                            <h3>Eingebettete Inhalte</h3>
                            <p>
                                Auf dieser Website werden keine externen Inhalte (z. B. Karten, Videos, 
                                Schriftarten von Drittanbietern) eingebettet, die eine zusätzliche 
                                Datenverarbeitung durch Dritte verursachen würden.
                            </p>

                            <h2>6. Pflichtangaben gemäß Art. 13 DSGVO</h2>
                            
                            <h3>Pflicht zur Bereitstellung der Daten</h3>
                            <p>
                                Die Bereitstellung Ihrer personenbezogenen Daten ist für die Nutzung 
                                dieser Website nicht gesetzlich vorgeschrieben. Bestimmte Funktionen 
                                (z. B. Kontaktformular) können jedoch nur genutzt werden, wenn Sie die 
                                dafür erforderlichen Daten angeben.
                            </p>

                            <h3>Keine automatisierte Entscheidungsfindung</h3>
                            <p>
                                Eine automatisierte Entscheidungsfindung einschließlich Profiling im 
                                Sinne von Art. 22 DSGVO findet nicht statt.
                            </p>

                            <h2>7. Datenschutzbeauftragter</h2>
                            <p>
                                Ein betrieblicher Datenschutzbeauftragter muss für unsere Praxis nach 
                                den gesetzlichen Vorgaben nicht bestellt werden.
                            </p>

                            <h2>8. Ihre Rechte</h2>
                            <p>
                                Sie haben im Rahmen der geltenden gesetzlichen Bestimmungen insbesondere 
                                folgende Rechte:
                            </p>
                            <ul>
                                <li>
                                    <strong>Recht auf Auskunft (Art. 15 DSGVO):</strong> Sie können 
                                    Auskunft über die bei uns verarbeiteten personenbezogenen Daten 
                                    verlangen.
                                </li>
                                <li>
                                    <strong>Recht auf Berichtigung (Art. 16 DSGVO):</strong> Sie können 
                                    die Berichtigung unrichtiger oder Ergänzung unvollständiger Daten 
                                    verlangen.
                                </li>
                                <li>
                                    <strong>Recht auf Löschung (Art. 17 DSGVO):</strong> Sie können die 
                                    Löschung personenbezogener Daten verlangen, soweit dem keine gesetzlichen 
                                    Aufbewahrungspflichten entgegenstehen.
                                </li>
                                <li>
                                    <strong>Recht auf Einschränkung der Verarbeitung (Art. 18 DSGVO):</strong> 
                                    Sie können die Einschränkung der Verarbeitung Ihrer Daten verlangen.
                                </li>
                                <li>
                                    <strong>Recht auf Widerspruch (Art. 21 DSGVO):</strong> Sie können 
                                    der Verarbeitung Ihrer Daten widersprechen, insbesondere wenn diese 
                                    zu Werbezwecken erfolgt.
                                </li>
                                <li>
                                    <strong>Recht auf Datenübertragbarkeit (Art. 20 DSGVO):</strong> Sie können 
                                    Ihre Daten in einem strukturierten, gängigen und maschinenlesbaren Format 
                                    erhalten.
                                </li>
                                <li>
                                    <strong>Recht auf Widerruf erteilter Einwilligungen (Art. 7 Abs. 3 DSGVO):</strong> 
                                    Sie können erteilte Einwilligungen mit Wirkung für die Zukunft widerrufen.
                                </li>
                            </ul>
                            <p>
                                <strong>Beschwerderecht:</strong> Sie haben das Recht, eine Beschwerde 
                                bei der zuständigen Aufsichtsbehörde einzulegen, wenn Sie der Ansicht 
                                sind, dass die Verarbeitung Ihrer personenbezogenen Daten gegen die 
                                DSGVO verstößt. Die zuständige Aufsichtsbehörde für Nordrhein-Westfalen ist:
                            </p>
                            <p>
                                <strong>Landesbeauftragte für Datenschutz und Informationsfreiheit 
                                Nordrhein-Westfalen</strong><br />
                                Postfach 20 04 44<br />
                                40102 Düsseldorf<br />
                                Telefon: 0211 38424-0<br />
                                E-Mail: poststelle@ldi.nrw.de<br />
                                Website: <a href="https://www.ldi.nrw.de/" target="_blank" rel="noopener noreferrer">https://www.ldi.nrw.de/</a>
                            </p>
                            <p>
                                Hierzu sowie zu weiteren Fragen zum Thema Datenschutz können Sie sich 
                                jederzeit an uns wenden.
                            </p>
                            
                            <div className="datenschutz-footer">
                                <hr />
                                <p>
                                    <strong>Stand:</strong> {new Date().toLocaleDateString('de-DE', { year: 'numeric', month: 'long', day: 'numeric' })}
                                </p>
                                <p>
                                    Diese Datenschutzerklärung wurde unter Berücksichtigung der 
                                    Anforderungen der DSGVO (Datenschutz-Grundverordnung) und des 
                                    DDG (Digital-Dienste-Gesetz) sowie der Empfehlungen der 
                                    Zahnärztekammer Nordrhein erstellt.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
        </>
    );
};

export default Datenschutz;

